var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#343434"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8966 7.32262L13.9577 5.38371C13.7046 5.14601 13.373 5.00962 13.026 5.00049C12.6789 4.99136 12.3406 5.11011 12.0754 5.33417L5.7067 11.7029C5.47797 11.9335 5.33555 12.2359 5.30335 12.5591L4.99907 15.5099C4.98954 15.6136 5.00298 15.718 5.03846 15.8159C5.07393 15.9137 5.13055 16.0026 5.20428 16.076C5.2704 16.1416 5.34882 16.1935 5.43504 16.2287C5.52125 16.2639 5.61357 16.2818 5.7067 16.2812H5.77039L8.72121 16.0123C9.04446 15.9801 9.34678 15.8377 9.57745 15.609L15.9461 9.2403C16.1933 8.97916 16.3269 8.63068 16.3176 8.27122C16.3083 7.91177 16.1569 7.57065 15.8966 7.32262ZM8.59384 14.5971L6.47094 14.7952L6.662 12.6723L10.6601 8.72373L12.5707 10.6343L8.59384 14.5971ZM13.4907 9.68611L11.5942 7.78966L12.9741 6.37439L14.9059 8.30623L13.4907 9.68611Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.51b8edd44cc34afe57b31f17c1f2fa89.svg";
export { ForwardRef as ReactComponent };